// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"light-box-m__wrapper__lVjcn","lightbox":"light-box-m__lightbox__kCcIo","icon-close":"light-box-m__icon-close__1LJtn"};